import React from 'react'

export default function FaceFeature({ scale, verticalOffset = 0 }) {
  const transformOrigin = '22.5 7.5'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M44.92 1.12001C44.92 1.12001 39.24 -0.0699842 22.52 1.44002C5.79003 -0.0699842 0.12 1.12001 0.12 1.12001C0.12 1.12001 -0.319968 4.88999 0.590032 8.40999C1.46003 11.77 3.78 13.53 10.31 14.11C17.27 14.73 18.71 13.34 20.14 9.61C21.29 6.61 21.84 5.83998 22.52 5.83998C23.2 5.83998 23.75 6.62 24.9 9.61C26.33 13.34 27.77 14.72 34.73 14.11C41.27 13.53 43.59 11.77 44.45 8.40999C45.35 4.88999 44.92 1.12001 44.92 1.12001ZM17.74 11.42C16.98 12.35 16.11 12.69 15.13 12.83C13.64 13.05 11.48 12.99 9.21998 12.72C5.92998 12.34 2.72999 11.49 1.85999 8.26002C1.02999 5.18002 1.04002 2.32999 3.20002 1.97999C5.27002 1.64999 18.29 1.22001 19.63 3.43001C20.35 4.62001 19.59 9.14 17.74 11.42ZM43.18 8.27003C42.31 11.5 39.1 12.35 35.82 12.73C33.55 13 31.39 13.06 29.91 12.84C28.93 12.7 28.05 12.36 27.3 11.43C25.45 9.14001 24.7 4.63003 25.41 3.45003C26.75 1.24003 39.77 1.67001 41.84 2.00001C44 2.33001 44.01 5.18003 43.18 8.27003Z"
        fill="#231F20"
      />
    </g>
  )
}
